// extracted by mini-css-extract-plugin
export default {"list":"ListComponents_list__WNHwT","listItem":"ListComponents_listItem__HTaTv"};